import React from 'react';

import { useFeatureFlags } from '@portals/api/partners';
import {
  DashboardContentLayout,
  RoutedTabs,
  RoutedTabsProps,
  isPartnerFeatureOn,
} from '@portals/framework';

import { SubscriptionsTable } from './SubscriptionsTable';

const ROUTES: RoutedTabsProps['routes'] = [
  {
    path: 'active',
    tabLabel: 'Active',
    element: (
      <SubscriptionsTable statuses={['active', 'pending_cancellation']} />
    ),
  },
  {
    path: 'suspended',
    tabLabel: 'Suspended',
    element: <SubscriptionsTable statuses={['suspended']} />,
  },
  {
    path: 'canceled',
    tabLabel: 'Canceled',
    element: <SubscriptionsTable statuses={['canceled']} />,
  },
];

export function Subscriptions() {
  const featureFlags = useFeatureFlags();

  return (
    <DashboardContentLayout
      bg="gray.0"
      pageTitle="Subscriptions"
      breadcrumbs={
        isPartnerFeatureOn(featureFlags, 'hubs')
          ? undefined
          : [
              { label: 'Store Management', to: '/store-management' },
              { label: 'Subscriptions' },
            ]
      }
    >
      <RoutedTabs routes={ROUTES} basePath="/store-management/subscriptions" />
    </DashboardContentLayout>
  );
}
